// extracted by mini-css-extract-plugin
export default {"success":"Alert_success__eyUfz","close":"Alert_close__b1coK"};